module.exports = __webpack_public_path__ + "img/bag1.bd0c3844.svg";